<template>
  <b-row>
    <b-col md="5">
      <campaign-summary :data-review="campaignDetail" />
    </b-col>
    <b-col
      v-if="status !== '3'"
      md="7"
    >
      <line-cart />
      <campaign-activity />
    </b-col>
    <b-col
      v-if="status === '3'"
      md="7"
    >
      <b-card>
        <h4 class="mb-2 text-primary font-weight-bolder text-uppercase">
          Reason
        </h4>
        <div
          v-for="(data, i) in reason"
          :key="i"
        >
          <b-alert
            variant="danger"
            show
          >
            <div class="alert-body">
              <span><strong>{{ data }}</strong></span>
            </div>
          </b-alert>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

import {
  BRow,
  BCol,
  BCard,
  BAlert,
} from 'bootstrap-vue'
import campaignSummary from '@/views/page/campaign/detail/Summary.vue'
import campaignActivity from '@/views/page/campaign/detail/Activity.vue'
import lineCart from '@/views/component/cart/CartLine.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    campaignSummary,
    lineCart,
    campaignActivity,
    BCard,
    BAlert,
  },
  data() {
    return {
      detail: {},
      reason: [],
      status: '',
    }
  },
  computed: {
    ...mapGetters('campaign', {
      dataCampaignItem: 'getCampaignManageItem',
      campaignId: 'getCampaignId',
      campaignDetail: 'getCampaignDetail',
    }),
  },
  created() {
    this.setCampaignDetail()
    this.setCampaignId(this.$route.params.id)
    this.getCampaignDetail(this.$route.params.id)
    // eslint-disable-next-line radix
    // this.getDetail(this.campaignId)
  },
  updated() {
    this.reason = this.campaignDetail.reason
    this.status = this.campaignDetail.status
    // console.log(this.status, 'deetail')
  },
  methods: {
    ...mapMutations('campaign', {
      setCampaignId: 'SET_CAMPAIGN_ID',
      setCampaignDetail: 'SET_DETAIL_CAMPAIGN',
    }),
    ...mapActions('campaign', {
      getCampaignDetail: 'getCampaignDetailList',
    }),
    getDetail(id) {
      // const campaigns = this.dataCampaignItem.data
      // const dataCampaign = campaigns.find(item => item.campaign_id === id)
      this.getCampaignDetail(id).then(() => {
        this.detail = this.campaignDetail
      })
    },
    setString(data) {
      let str = (data) || []
      return str.toString()
    },
    goPage(url) {
      this.$router.push({ name: url })
    },
  },
}
</script>
